import { useCallback } from "react";
import { authClient } from "@/lib/auth-client";
import { useAuth } from "@/providers/auth-provider";

export const endSessions = async () => {
  await authClient.signOut();
};

export const useSignOut = () => {
  const { onSignOut } = useAuth();

  return useCallback(async () => {
    await endSessions();
    await onSignOut();
  }, [onSignOut]);
};
